module.exports = __webpack_public_path__ + "media/images/partner/baselland-amt-fuer-gesundheit-5ea0bded591335078a907685511e3d16.png";